import MobileServiceClient from "@mocobaas/client-js/build/MobileServiceClient";
import {
  GetListParams,
  GetListResult,
  CreateParams,
  CreateResult,
  GetManyParams,
  GetManyResult,
  GetOneParams,
  GetOneResult,
  DeleteParams,
  DeleteResult,
  UpdateParams,
  UpdateResult,
} from "react-admin";
import gql from "graphql-tag";
import { ProviderBase } from "./ProviderBase";
import { buildArgs } from "./utils";
import { v4 as uuid } from "uuid";

const uriTest = "develop.m21-console.pages.dev";
const uriDev = "localhost:3000";

// Create a reusable function for GraphQL fetch requests
export async function graphqlFetch({
  url,
  query,
  variables,
}: {
  url: string;
  query: string;
  variables: Record<string, any>;
}): Promise<any> {
  let bearer: string | null = null;
  try {
    bearer = localStorage.getItem("MBaaS.auth.accessToken");
  } catch (_) {
    bearer = null;
  }

  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };
  
  if (bearer) {
    headers["Authorization"] = `Bearer ${bearer}`;
  }

  const response = await fetch(url, {
    method: "POST",
    headers,
    body: JSON.stringify({ query, variables }),
  });

  if (!response.ok) {
    throw new Error(`GraphQL request failed with status ${response.status}`);
  }

  return response.json();
}

export class SmartfrenVirtualMsisdnProviderClass extends ProviderBase<any> {
  client: MobileServiceClient;

  constructor(client: MobileServiceClient) {
    super();
    this.client = client;
  }

  async getList(
    resource: string,
    params: GetListParams
  ): Promise<GetListResult<any>> {
    console.log({ method: "getList", resource, params });
    const where: Record<string, any> = {};
    const filterArray: any[] = [];

    filterArray.push({
      is_deleted: {
        _eq: false,
      },
    });

    filterArray.push({
      operator: {
        _eq: "SMARTFREN",
      },
    });

    if (params.filter.selectedIds) {
      filterArray.push({
        id: {
          _in: [...params.filter.selectedIds],
        },
      });
    }

    if (params.filter.q) {
      filterArray.push({
        msisdn: {
          _ilike: `%${params.filter.q}%`,
        },
      });
    }

    if (params.filter.is_pool !== undefined) {
      filterArray.push({
        is_pool: {
          _eq: params.filter.is_pool === 1 ? true : false,
        },
      });
    }

    if (params.filter.status) {
      filterArray.push({
        status: {
          _eq: params.filter.status,
        },
      });
    }

    if (params.filter.country) {
      filterArray.push({
        country: {
          _eq: params.filter.country,
        },
      });
    }

    if (params.filter.map_to !== undefined) {
      if (params.filter.map_to === "NULL") {
        filterArray.push({
          map_to: { _is_null: true },
        });
      } else {
        filterArray.push({
          map_to: { _eq: params.filter.map_to },
        });
      }
    }

    if (params.filter.userName) {
      filterArray.push({
        user: {
          name: {
            _ilike: `%${params.filter.userName}%`,
          },
        },
      });
    }

    if (params.filter.user_id) {
      filterArray.push({
        user: {
          id: {
            _eq: params.filter.user_id,
          },
        },
      });
    }

    if (params.filter.userPhone) {
      filterArray.push({
        user: {
          _or: [
            { phone: { _ilike: `%${params.filter.userPhone}%` } },
            { name: { _ilike: `%${params.filter.userPhone}%` } },
          ],
        },
      });
    }

    if (params.filter.virtualNumber) {
      filterArray.push({
        msisdn: {
          _ilike: `%${params.filter.virtualNumber}%`,
        },
      });
    }

    if (filterArray.length > 0) where._and = filterArray;

    const { page, perPage } = params.pagination;
    let { field, order } = params.sort;

    if (params.sort.field === "user_id_data") {
      field = "user_id";
    }

    const args = buildArgs({
      // @ts-ignore
      order: order || "DESC",
      size: perPage,
      pageNumber: page,
      sort: field || "created_at",
    });

    const queryResult = await graphqlFetch({
      url: [uriTest, uriDev].includes(window.location.host)
        ? "https://console.gql.m21-ng-core.develop.telinhk.xyz/mobile/v1/graphql"
        : "https://console.gql.m21-ng-core.live.telinhk.xyz/mobile/v1/graphql",
      query: `
        query sfVirtualMsisdn(
          $where: virtual_msisdn_bool_exp
          $limit: Int
          $offset: Int
          $orderBy: [virtual_msisdn_order_by!]
        ) {
          virtual_msisdn(
            where: $where
            limit: $limit
            offset: $offset
            order_by: $orderBy
          ) {
            allocation_date
            country
            created_at
            expiry_date
            free_date
            from_as2in1
            hkd_price
            id
            is_auto_renewed
            is_pool
            map_to
            metadata
            msisdn
            operator
            status
            suspended_at
            updated_at
            user {
              id
              name
              email
              phone
            }
          }
          virtual_msisdn_aggregate(where: $where) {
            aggregate {
              count
            }
          }
        }
      `,
      variables: {
        where,
        limit: perPage,
        offset: (page - 1) * perPage,
        orderBy: [{ [field]: order.toLowerCase() }],
      },
    });

    return {
      data: queryResult?.data?.virtual_msisdn || [],
      total: queryResult?.data?.virtual_msisdn_aggregate?.aggregate?.count || 0,
    } as GetListResult;
  }

  async create(
    resource: string,
    params: CreateParams<any>
  ): Promise<CreateResult<any>> {
    const newUuid = uuid();
    console.log({ method: "create", resource, params });

    const toBeCreatedData: any = {
      ...params.data,
      id: newUuid,
      country: "ID",
      hkd_price: 0,
      operator: "SMARTFREN",
      is_pool: true,
      status: "FREE",
    };
    console.log(723, "toBeCreatedData", toBeCreatedData);

    // Refactor the mutation function to use graphqlFetch
    const queryResult = await graphqlFetch({
      url: [uriTest, uriDev].includes(window.location.host)
        ? "https://console.gql.m21-ng-core.develop.telinhk.xyz/mobile/v1/graphql"
        : "https://console.gql.m21-ng-core.live.telinhk.xyz/mobile/v1/graphql",
      query: `
        mutation createVirtualMsisdn($object: virtual_msisdn_insert_input!) {
          insert_virtual_msisdn_one(object:$object) {
            id
            msisdn
            hkd_price
            country
          }
        }
      `,
      variables: {
        object: toBeCreatedData,
      },
    });

    return {
      data: queryResult?.data?.insert_virtual_msisdn_one,
    } as CreateResult;
  }

  async getMany(
    resource: string,
    params: GetManyParams
  ): Promise<GetManyResult<any>> {
    console.log({ method: "getMany", resource, params });
    const where: Record<string, any> = {};
    if (params.ids) {
      where._or = [
        {
          id: {
            _in: params.ids,
          },
        },
      ];
    }
    const queryResult = await this.client.gql.query({
      query: gql`
        query virtualMsisdn($where: VirtualMsisdnWhereInput) {
          allVirtualMsisdnList(where: $where) {
            data {
              id
              msisdn
            }
          }
        }
      `,
      variables: {
        where,
      },
    });
    return {
      data: queryResult?.allVirtualMsisdnList?.data,
    } as GetManyResult;
  }

  async getOne(
    resource: string,
    params: GetOneParams<any>
  ): Promise<GetOneResult<any>> {
    console.log({ method: "getOne", resource, params });

    const queryResult = await graphqlFetch({
      url: [uriTest, uriDev].includes(window.location.host)
        ? "https://console.gql.m21-ng-core.develop.telinhk.xyz/mobile/v1/graphql"
        : "https://console.gql.m21-ng-core.live.telinhk.xyz/mobile/v1/graphql",
      query: `
        query getOneSFVirtualMsisdn($id:uuid!){
          virtual_msisdn_by_pk(id:$id){
            allocation_date
            country
            created_at
            expiry_date
            free_date
            from_as2in1
            hkd_price
            id
            is_auto_renewed
            is_pool
            map_to
            metadata
            msisdn
            operator
            status
            suspended_at
            updated_at
            user_id
            user {
              id
              name
              email
            }
          }
        }
      `,
      variables: {
        id: params?.id || "",
      },
    });

    const returnedData = {
      ...queryResult?.data?.virtual_msisdn_by_pk,
      is_auto_renewed: queryResult?.data?.virtual_msisdn_by_pk?.is_auto_renewed
        ? 1
        : 0,
      is_pool: queryResult?.data?.virtual_msisdn_by_pk?.is_pool ? 1 : 0,
    };

    return {
      data: returnedData,
    } as GetOneResult;
  }

  async delete(
    resource: string,
    params: DeleteParams<any>
  ): Promise<DeleteResult<any>> {
    // using soft delete, update the is_deleted flag to true
    console.log({ method: "delete", resource, params });

    const queryResult = await graphqlFetch({
      url: [uriTest, uriDev].includes(window.location.host)
        ? "https://console.gql.m21-ng-core.develop.telinhk.xyz/mobile/v1/graphql"
        : "https://console.gql.m21-ng-core.live.telinhk.xyz/mobile/v1/graphql",
      query: `
        mutation deleteSFVirtualMsisdn($id:uuid!){
          update_virtual_msisdn_by_pk(pk_columns:{id:$id}, _set:{is_deleted:true}){
            id
          }
        }
      `,
      variables: {
        id: params.id,
      },
    });

    if (queryResult?.errors) {
      throw new Error(queryResult.errors[0].message);
    }

    return {
      data: queryResult?.data?.update_virtual_msisdn_by_pk?.id,
    } as DeleteResult;
  }

  async update(
    resource: string,
    params: UpdateParams<any>
  ): Promise<UpdateResult<any>> {
    console.log({ method: "update", resource, params });
    const submittedData = {
      ...params.data,
      is_auto_renewed: params.data.is_auto_renewed === 1 ? true : false,
      is_pool: params.data.is_pool === 1 ? true : false,
    };

    const queryResult = await graphqlFetch({
      url: [uriTest, uriDev].includes(window.location.host)
        ? "https://console.gql.m21-ng-core.develop.telinhk.xyz/mobile/v1/graphql"
        : "https://console.gql.m21-ng-core.live.telinhk.xyz/mobile/v1/graphql",
      query: `
        mutation updateSFVirtualMsisdn($pkColumns:virtual_msisdn_pk_columns_input!, $set:virtual_msisdn_set_input){
          update_virtual_msisdn_by_pk(pk_columns:$pkColumns, _set:$set){
            id
          }
        }
      `,
      variables: {
        pkColumns: {
          id: params.id,
        },
        set: submittedData,
      },
    });

    return {
      data: queryResult?.data?.update_virtual_msisdn_by_pk,
    } as UpdateResult;
  }
}
